/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Deutsch (Deutsch)
 * 
 * 805290001 = Englisch (Englisch)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceSprache {
 Deutsch = 805290000,
 Englisch = 805290001
}

marker([
    "Enum.GlobalEnumsAceSprache.Deutsch",
    "Enum.GlobalEnumsAceSprache.Englisch"
]);

export namespace GlobalEnumsAceSprache
{
    class DataSets
    {
        static GlobalEnumsAceSpracheDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Deutsch", 805290000, "Deutsch"),
            new EnumValue("Englisch", 805290001, "Englisch"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceSpracheDataSet;
    }
}
